export const LABELS = {
    designType: "Choose your Design type",
    chooseDesignType: "Choose design type for this case",
    esp: "ESP",
    jetLift: "Jet lift",
    jetLiftSizing: "Jet lift sizing",
    comparison: "Comparison",
    reports: "Reports",
    equipmentOffering: "Equipment offering",
    projectSummary: "Project summary",
    casing: "Casing",
    casingOD: "Casing OD",
    casingWeight: "Casing weight",
    casingID: "Casing ID",
    casingDriftID: "Casing drift ID",
    liner: "Liner",
    linerOD: "Liner OD",
    linerWeight: "Liner weight",
    linerID: "Liner ID",
    linerTopMD: "Liner top @MD",
    FT: "FT",
    ft: "ft",
    in: "in",
    tubing: "Tubing",
    tubing1: "Tubing - 1",
    tubing2: "Tubing - 2",
    installType: "Install type",
    std: "Standard flow",
    reverseFlow: "Reverse flow",
    parallel: "Parallel",
    concentric: "Concentric",
    porductionFlowId: "Production flow id",
    parallelTubing1: "Tubing 1 - Power fluid string",
    parrallelTubing2: "Tubing 2 - Return string",
    concentricTubing1: "Tubing 1 - Outer string",
    concentricTubing2: "Tubing 2 - Inner string",
    tubingOD: "Tubing OD",
    tubingType: "Tubing type",
    tubingWeight: "Tubing weight",
    tubingID: "Tubing ID",
    wellTrajectory: "Well trajectory",
    wellTrajectoryVertical: "Vertical",
    wellTrajectoryDirectional: "Directional",
    well: "Well",
    surfaceConditions: "Surface conditions",
    tubingPressure: "Tubing pressure",
    casingPressure: "Casing pressure",
    flowLinePressure: "Flow line pressure",
    psi: "psi",
    bpd: "bpd",
    iprType: "IPR type",
    inflowType: "Inflow type",
    pi: "PI",
    pressure: "Pressure",
    head: "Head",
    wellHeadPressure: "Well head pressure",
    staticBtmHolePressure: "Static bottom hole pressure",
    staticFluidLevel: "Static fluid level from surface",
    producingFluidLevel: "Producing fluid level from surface",
    flowingBtmHolePressure: "Flowing bottom hole pressure",
    testFlowRate: "Test flow rate",
    productivityindex : "Productivity index ",
    desiredProductionRate: "Desired production rate",
    pumpSuctionPressure: "Desired pump suction pressure",
    settingDepth: "Setting depth",
    ft1: "ft",
    settingDepthRef: "Setting depth reference",
    sensor: "Sensor",
    intake: "Intake",
    setDepth: "Set depth (btm)",
    pumpSettingVerticalDepth: "Pump setting @ vertical depth",
    reservoirDatum: "Reservoir DATUM",
    flop: "Flop @ Desired production rate",
    fluid: "Fluid",
    spGrWater: "SpGrWater",
    waterCut: "Water cut",
    waterCutError: "Please provide value less than 100.",
    percentage: "%",
    bwpd: 'BWPD',
    oilProperty: "Oil property",
    oilAPI: "Oil API",
    spGrOil: "SpGr Oil",
    spGrw: "SpGrW",
    oilCut: "Oil cut",
    bopd: "BOPD",
    averageCompositeSpGr: "Average composite SpGr",
    liquidPhaseCompositeSpGr: "Liquid phase composite SpGr",
    fluidViscosity: "Fluid viscosity",
    fluidViscosityUnit: "P",
    gasProperties: "Gas properties",
    gasAvailability: "Gas availability",
    gasVolume: "Gas volume",
    gasProduction: "Gas production",
    gasProductionUnit: "mcf",
    gor: "GOR",
    glr: "GLR",
    gorGlrUnit: "scf/stb",
    specificGravityOfGas: "Specific gravity of gas",
    gasCompressibility: "Gas compressibility",
    autoGasCompressibility: "Auto gas compressibility",
    bubblePoint: "Bubble point",
    maxBubblePoint: "Max bubble point",
    bottomHoleTemp: "Bottom hole temp",
    surfaceTemp: "Surface temp",
    tempUnit: "°F",
    correlations: "Correlations",
    region: "Region",
    jetPump: "Jet pump",
    manufacturer: "Manufacturer",
    powerFluidPressureRange: "Power fluid pressure range",
    diameter: "Diameter",
    Size: "Size",
    area: "Area",
    oilapi: "Oil API",
    powerFluidType: "Power fluid type",
    minimum: "Minimum",
    maximum: "Maximum",
    step: "Step",
    powerFluidDensity: "Power fluid density",
    outputPressures: "Output pressures",
    gasVented: "Gas vented",
    customerSize: "Customer size",
    others: "Others",
    powerConditions: "Power conditions",
    supplyPower: "Supply power",
    distribution: "Distribution",
    generator: "Generator",
    supplyVoltage: "Supply voltage / Hz",
    availableKVA: "Available KVA",
    controller: "Controller",
    softStart: "Soft-start",
    swb: "SWB",
    vsd: "VSD",
    gasImpurities: "Gas impurities",
    oxygen: "Oxygen (O2)",
    nitrogen: "Nitrogen (N2)",
    h2s: "H2S",
    co2: "CO2",
    problemsConcerns: "Problems / Concerns",
    corrosion: "Corrosion",
    paraffin: "Paraffin",
    scale: "Scale",
    sandSolids: "Sand / Solids",
    viscosityEmulsion: "Viscosity / Emulsion",
    packerRequired: "Packer required",
    chemical: "Chemical",
    yTool: "Y-tool",
    scdaCompatibility: "SCDA compatibility",
    pressureSensor: "Pressure sensor",
    addNotes: "Add notes",
    numberError: "Please enter a valid number.",
    yes: "Yes",
    no: "No",
    select: "Select",
    blpd: "blpd",
    psia: "psia",
    hp: "HP",
    mcfpd: "mcfpd",
    summary: "Summary",
    targetProductionRate: "Target production rate",
    pumpIntakePressure: "Pump intake pressure",
    predictedSurfacePowerFluidInjectionPressure: "Predicted surface power fluid injection pressure",
    predictedSurfacePowerFluidInjectionRate: "Predicted surface power fluid injection rate",
    predictedPumpIntakePressure: "Predicted pump intake pressure",
    predictedPumpDischargePressure: "Predicted pump discharge pressure",
    predictedPowerFluidPressureAtPump: "Predicted power fluid pressure at pump depth",
    predictedHorsePowerRequirement: "Predicted horse power requirement",
    matchProductionRate: "Match production rate",
    matchPowerFluidPressure: "Match power fluid pressure",
    matchPowerFluidRate: "Match power fluid rate",
    matchPumpIntakePressure: "Match pump intake pressure",
    pumpDischargePressure: "Pump discharge pressure",
    matchPowerFluidPressureAtPump: "Match power fluid pressure @ pump",
    maxHPRequirement: "Max HP requirement",
    wellInflowCals: "well inflow calculations",
    wellIPRCals: "Well IPR calculations (expand to see IPR curves)",
    surfaceEquipment: "Surface equipment",
    schematics: "Schematic",
    jetPumpSize: "Jet pump size",
    performanceCurves: "Performance curves",
    importFromExcel: "Import from excel",
    exportToExcel: "Export to excel",
    clearData: "Clear data",
    btnImport: "Import",
    typePrimary: "primary",
    excelInputs: "Excel inputs",
    md: "MD",
    inc: "INC",
    dls: "DLS",
    azi: "AZI",
    startCellLocation: "Start cell location",
    endCellLocation: "End cell location",
    sheetName: "Sheet name",
    includeInMainReport: "Include in main report",
    kop: "KOP (ft)",
    topESPPump: "Top of ESP pump (ft)",
    bottomESPSensor: "Bottom of ESP sensor (ft)",
    maxDLSaboveKop: "Max DLS above KOP",
    depthOfMaxDLS: "Depth of max DLS (ft)",
    casingSize: "Casing size",
    transitionZone: "Transition zone (TZ)",
    espLength: "ESP length (ft)",
    tailPipeDesander: "Tail Pipe + Desander (ft)",
    tailPipeBottom: "Tail pipe bottom (ft)",
    tailPipeInsideTZ: "% Tail pipe inside TZ",
    tubingSize: "Tubing size",
    espSettingDepthSUrvey: "ESP setting depth survey",
    notes: "Notes",
    exportWellSurveyPlot1: "Export well survey plot 1",
    exportWellSurveyPlot2: "Export well survey plot 2",
    headCurves: "Head curves",
    wellsurveyplot1: "Well survey plot 1",
    wellsurveyplot2: "Well survey plot 2",
    rs: "Rs (scf/bbl)",
    bg: "Bg (bbl/mcf)",
    bo: "Bo (bbl/stb)",
    volumeOfGas: "Volume of gas (bpd)",
    volumeOfOil: "Volume of oil (bpd)",
    volumeOfWater: "Volume of water (bpd)",
    totalFluidVolume: "Total fluid volume (bpd)",
    freeGas: "Free Gas / GVF (%)",
    liquidPhaseDensity: "Liquid phase density (lb/ft^3)",
    compositeSpGr: "Composite SpGr",
    finalFlop: "Final flop (ft)",
    liquidPhaseSpGr: "Liquid phase SpGr",
    finalTemp: "Final temperature (°F)",
    futureShutInPresssure: "Future shutin pressure",
    futureProductionRate: "Future production rate",
    depletion: "Depletion",
    exportDepletionPlot: "Export depletion-plot",
    exportIprPlot: "Export IPR-plot",
    wellInflowPerformance: "Well inflow performance",
    performanceCurve1: "Performance curve",
    depletionCurve: "Depletion curve",
    startCellMd: "startCellMd",
    startCellInc: "startCellInc",
    startCellAziDls: "startCellAziDls",
    endCellMd: "endCellMd",
    endCellInc: "endCellInc",
    endCellAziDls: "endCellAziDls",
    sheetNameMd: "sheetNameMd",
    noFileSelected: "No file selected",
    chooseFile: "Choose file",
    inputType: "input",
    textWithUnitType: "textUnit",
    textType: "text",
    labelType: "label",
    radioType: "radio",
    radiosType: "radios",
    radioInputType: "radioInput",
    checkboxType: "checkbox",
    selectType: "select",
    fileType: "file",
    fileUpload: "file-upload",
    sizingSummary: "DETERMINE sizing summary",
    sizingSummaryDescription: "The sizing summary provides an overview of the Jet lift design's key components, along with the downhole and operating conditions.",
    casingTubing: "Casing / Tubing",
    wellDepths: "Well depths",
    pumpSettingMD: "Pump setting MD",
    pumpSettingVD: "Pump setting VD",
    datum: "Datum",
    wellIpr: "Well / IPR @ Datum",
    staticBHP: "Static BHP",
    flowingBHP: "Flowing BHP",
    staticFL: "Static FL",
    productingFL: "Producing FL",
    operatingPerformance: "Operating performance",
    productionRate: "Production rate",
    pip: "PIP",
    fluidProperties: "Fluid properties",
    regionalPV: "Regional PV",
    oilAPISP: "Oil API / SP",
    waterGravity: "Water gravity",
    surfaceFluid: "Surface fluid",
    bottomHole: "Bottom hole",
    gasGravity: "Gas gravity",
    fluidComp: "Fluid comp",
    liquidPhase: "Liquid phase",
    equipment: "Equipment",
    chemicalInjectionPerformance: "Chemical injection performance",
    wellDepth: "Well depth",
    wellIprDatum: "Well / IPR @ DATUM",
    nozzle: "Nozzle",
    throat: "Throat",
    size: "size",
    surfacePumpSize: "Surface pump size",
    plungerSize: "Plunger size",
    vesselSize: "Vessel size",
    chargePumpSize: "Charge pump size",
    recommended: "Recommended",
    selected: "Selected",
    downholeEquipmentSize: "Downhole equipment size",
    minimumId: "Minimum ID",
    downholeOperatingPerformance: "Downhole operating performance",
    oilRate: "Oil rate",
    waterRate: "Water rate",
    gasRate: "Gas rate",
    requiredSystemTDH: "Required system TDH",
    totalSystemTDH: "Total system TDH",
    ipranddepeltion: "DETERMINE well inflow & depletion curve",
    performanceCurve: "DETERMINE performance curve",
    performanceDescription: "Projected performance for the ESP design.",
    inputProperties: "Input properties",
    perforationDepth: "Perforation depth",
    pumpVerticalDepth: "Pump vertical depth",
    pumpInstallation: "Pump installation",
    casingInstallation: "Casing installation",
    casingProdId: "Casing (production) ID",
    powerTubingId: "Power tubing ID",
    powerTubingOD: "Power tubing OD",
    tubingLength: "Tubing length",
    pipeRoughness: "Pipe roughness e/d (L/L)",
    oilGravity: "Oil gravity (API)",
    producedVolWaterCut: "Produced vol water cut",
    waterSpecificGravity: "Water specific gravity",
    producingGOR: "Producing GOR (scf/stb)",
    gasSpGravity: "Gas Sp. Gravity (air=1)",
    separatorPress: "Separator press",
    wellStaticBHP: "Well static BHP",
    pumpIntakePress: "Pump Intake press",
    wellTestFlowRate: "Well test flow rate",
    wellHeadTemp: "Well head temp",
    powerFluidOilWater: "Power fluid oil/water",
    powerFluidAPI: "Power Fluid API",
    wellHeadPress: "Well head press",
    pumpPerformanceSummary: "Pump performance summary",
    diameters: "diameters",
    and: "and",
    injectionPressureResultsFor: "Injection pressure results for",
    reservoirPressure: "Reservoir pressure",
    calcualtedPIatDataPoint: "Calculated PI at data point",
    tangent: "Tangent",
    darcey: "Darcey",
    case1: "Case #1",
    case2: "Case #2",
    case3: "Case #3",
    intakePressure: "Intake pressure",
};
